export function getShareLink(locale, path) {
  return locale && path
    ? `${window.location.protocol}//${window.location.host}${locale}/${path}`
    : window.location.href
}

export function copyShareLink(element, shareLink) {
  element.select()
  element.setSelectionRange(0, shareLink.length)
  const successful = document.execCommand('copy')
  return successful
}

export function shareToFacebook(shareLink) {
  if (window.FB) {
    window.FB.ui(
      {
        display: 'popup',
        method: 'share',
        mobile_iframe: true,
        href: shareLink
      },
      response => {}
    )
  } else {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + shareLink, '', 'width=550,height=285&resizable=1')
  }
}

export function shareToTwitter(shareLink, text = '') {
  let url = `https://twitter.com/intent/tweet?url=${shareLink}`
  if (text) url += `&text=${text}`
  window.open(
    url,
    '',
    'width=550,height=285&resizable=1'
  )
}

export function shareToLine(shareLink) {
  window.open(`https://social-plugins.line.me/lineit/share?url=${shareLink}`, '', 'width=600,height=580')
}

export function shareToGooglePlus(shareLink) {
  window.open(`https://plus.google.com/share?url=${shareLink}`, '', 'width=520,height=480')
}

export function shareToPlurk(shareLink) {
  window.open(`https://www.plurk.com/?status=${shareLink}`, '', 'width=600,height=580')
}

export function shareToWeibo(shareLink, title = '', appkey, pic, ralateUid, language) {
  window.open(
    'https://service.weibo.com/share/share.php?' +
      'url=' +
      shareLink +
      // 'appkey=' + '' +
      // 'pic=' + '' +
      // 'ralateUid=' + '' +
      // 'language=' + '' +
      '&title=' +
      title,
    '',
    'width=440,height=430'
  )
}

export function getURLsQRCode(shareLink, width = 200, height = 200) {
  // return QR code
  return `https://chart.googleapis.com/chart?cht=qr&chs=${width}x${height}&chl=${shareLink}`
}
